import React from 'react'

import styled from 'styled-components'

import withdrawLogo from 'assets/images/withdraw-zero-balance.png'
import ConfirmationModal from 'components/ConfirmationModal'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { style } from 'theme'

import {
  RedStyledCloseAccountButton,
  StyledBody,
  StyledCard,
  StyledCloseAccountButton,
  StyledHeading,
  StyledImage,
} from '../components'
import { MergedProps } from './index'
import { CloseLaterConfirmationModalViewed } from './segment'

const BodyContainer = styled.div`
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    align-self: center;
    margin: auto;
  }
`
const Card = styled(StyledCard)<{ innerHeight?: number }>`
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    height: ${(props) => `calc(${props.innerHeight}px - 78px)`};
  }
`

const WVCard = styled(StyledCard)<{ innerHeight?: number }>`
  height: ${(props) => `calc(${props.innerHeight}px - 80px)`};
  &&& {
    border-radius: 0;
  }
`

export const RequestScreen: React.FC<MergedProps> = ({
  laterBalance,
  handleCloseAccountSelection,
  handleWithdrawLater,
  modalActions,
  modalBody,
  modalHeader,
  recurringInvestments,
  setShowCloseAccountModal,
  showCloseAccountModal,
  isWebView,
}) => {
  const CardComponent = isWebView ? WVCard : Card
  const { height } = useWindowDimensions()
  return (
    <>
      {!laterBalance && (
        <>
          <CardComponent innerHeight={isWebView ? height : null}>
            <BodyContainer>
              <StyledImage src={withdrawLogo} />
              <StyledBody>
                If you close your Later account, you’ll miss out on the easiest
                way to save for retirement.
              </StyledBody>
            </BodyContainer>

            <RedStyledCloseAccountButton
              onClick={handleCloseAccountSelection}
              disabled={recurringInvestments === undefined}
            >
              Close account
            </RedStyledCloseAccountButton>
          </CardComponent>

          {showCloseAccountModal && (
            <ConfirmationModal
              actions={modalActions}
              body={modalBody}
              header={modalHeader}
              onRequestClose={() =>
                setShowCloseAccountModal(!showCloseAccountModal)
              }
              isOpen={showCloseAccountModal}
              eventFields={CloseLaterConfirmationModalViewed}
            />
          )}
        </>
      )}

      {laterBalance && (
        <CardComponent innerHeight={isWebView ? height : null}>
          <BodyContainer>
            <StyledImage src={withdrawLogo} />
            <StyledHeading>Before you can close your account</StyledHeading>
            <StyledBody>
              We'll need to ask you a few questions in order to process your
              withdrawal.
            </StyledBody>
          </BodyContainer>

          <StyledCloseAccountButton onClick={handleWithdrawLater}>
            Next
          </StyledCloseAccountButton>
        </CardComponent>
      )}
    </>
  )
}
